export const originalColors = [
    'rgba(147, 87, 153, 1)',
    'rgba(25, 79, 155,1)',
    'rgba(255, 159, 64, 1)',
    'rgba(96, 189, 104, 1)',
    'rgba(236, 112, 99, 1)',
    'rgba(255, 201, 65, 1)',
    'rgba(123, 200, 143, 1)',   
    'rgba(241, 88, 84, 1)',    
    'rgba(121, 134, 203, 1)',  
    'rgba(255, 112, 67, 1)',   
    'rgba(102, 204, 255, 1)',  
    'rgba(204, 153, 255, 1)', 
];

